/**
 * {@link LayerBit} is a bitflag that can be used to reference {@link Layer Layers} of specific type.\
 * When an {@link ViewInvalidator.invalidate invalidation} occurs, its effect may be limited to specific {@link Layer Layer(s)}.
 *
 * For example when contour's color changes, that change is effective only on {@link ContourLayer}.\
 * And as such, we might want to limit the {@link ViewInvalidator.invalidate invalidation} to only affect {@link ContourLayer}s.
 *
 * However there are also events that are effective on all {@link Layer Layers}, such as panning.\
 * For such cases {@link LayerBit} of type {@link LayerBit.ALL_LAYERS ALL_LAYERS} may be used.\
 * It covers all the {@link Layer Layers}.
 *
 * If only subset of {@link Layer Layers} are affected, one may use the bitwise operations. Such as\
 * {@link LayerBit.IMAGE_LAYER_BIT} | {@link LayerBit.CONTOUR_LAYER_BIT} to affect only layers of those two types.
 */

export enum LayerBit {
    ALL_LAYERS = ~0,
    IMAGE_LAYER_BIT = 1,
    CONTOUR_LAYER_BIT = 2,
    DOSE_LAYER_BIT = 4,
}
